// Where the once-a-day "Which desk are you at?" prompt renders: a slot in the dashboard header
// row, between the search box and the icons (CU-869fn0jee follow-up). The prompt portals into it
// when it exists; a page without the dashboard header keeps the floating pill.
export const HEADER_DESK_SLOT_ID = 'header-desk-slot';

export const findHeaderDeskSlot = () => (typeof document !== 'undefined' ? document.getElementById(HEADER_DESK_SLOT_ID) : null);
